import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {CopyRotation} from './copy-rotation.js';

/**
 * copy-rotation-switch-other
 */
export class CopyRotationSwitchOther extends Component {
    static TypeName = 'copy-rotation-switch-other';

    /* Properties that are configurable in the editor */

    @property.object({required: true})
    inVr!: Object3D;

    @property.object({required: true})
    inNonVr!: Object3D;

    start() {
        const copyRotation = this.object.getComponent(CopyRotation)!;
        this.engine.onXRSessionStart.add(() => (copyRotation.other = this.inVr));
        this.engine.onXRSessionEnd.add(() => (copyRotation.other = this.inNonVr));
    }
}
